export const VERIFICATION_STEPS = {
  CHOOSE_METHOD: 'choose_method',
  EMAIL_VERIFICATION: 'email_verification',
  SMS_VERIFICATION: 'sms_verification',
  SUCCESS: 'success'
};

export const VERIFICATION_METHODS = {
  EMAIL: 'email',
  SMS: 'sms'
};

export const VERIFICATION_CONFIG = {
  CODE_LENGTH: 5,
  RESEND_COOLDOWN_SECONDS: 60,
  MAX_ATTEMPTS: 3,
  CODE_EXPIRY_MINUTES: 10
};



export const formatPhone = (phone) => {
  if (!phone) return '';  
  if (phone.length === 10) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  }
  if (phone.length > 10) {
    return `***-***-${phone.slice(-4)}`;
  }  
  return phone;
};

export const validateVerificationCode = (code, length = 5) => {
  const regex = new RegExp(`^\\d{${length}}$`);
  return regex.test(code);
};

export const getStepProgress = (currentStep) => {
  const steps = Object.values(VERIFICATION_STEPS);
  const currentIndex = steps.indexOf(currentStep);
  return ((currentIndex + 1) / steps.length) * 100;
};

